export const factorial = (n) => {
  return (n!==1) ? n*factorial(n-1) : 1;
};

export const systemSize = (max, size) => {
  return factorial(max) / ( factorial(size) * factorial(max-size) )
};


export const objIsEmpty = (obj) => {
  for (let prop in obj) {
    if(obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
};


export const round = (x) => {
  return Math.round(x*1000)/1000;
};

export const roundTwo = (x) => {
  return Math.round(x*100)/100;
};
